import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Pagination from "../../../../components/Pagination";
import api from "../../../../api/api";
import * as bootstrap from "bootstrap";
import BackButton from "../../../../components/BackButton";
import "../../Common/form.css";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";
import ForwardIcon from "@mui/icons-material/Forward";

const JobMaster = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get current user and check if they can edit
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const allowedEditors = ["GFR003", "GFR009", "wMe2inT9YF9i"];
  const canEdit = allowedEditors.includes(user?.user_id);

  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(enquiries, 5);

  useEffect(() => {
    const fetchEnquiries = async () => {
      setLoading(true);
      try {
        const response = await api.get("/master-data/container-status-report");
        console.log("response.data.bookings", response.data.bookings);

        setEnquiries(response.data.bookings);
      } catch (error) {
        setError("Failed to fetch enquiries");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchEnquiries();
  }, []);

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [enquiries, currentPage]);

  const columns = [
    { label: "Job Number", accessor: "job_number" },
    { label: "BL Number", accessor: "BL_id" },
    { label: "Shipper Name", accessor: "first_shipper_name" },
    { label: "Consignee Name", accessor: "first_consignee_name" },
    { label: "Place Of Receipt", accessor: "Placeof_Receipt" },
    { label: "Discharge Port", accessor: "pod" },
    {
      label: "Action",
      render: (row) => (
        <>
          {/* <Link 
            to={`/view-booking-documents/${row.enq_id}`} 
            className="me-2"
            title="View Documents"
          >
            <NoteIcon />
          </Link> */}
          {!canEdit && (
            <Link
              to={`/edit-container-status/${row.enq_id}`}
              className="me-2"
              title="View Details"
            >
              <VisibilityIcon />
            </Link>
          )}
          {canEdit && (
            <Link to={`/edit-container-status/${row.enq_id}`} title="Edit">
              <ForwardIcon />
            </Link>
          )}

          {/* <Link 
            to={`/new
              /${row.enq_id}`} 
            className="me-2"
            title="forward"
          >
            <ForwardIcon  />
          </Link> */}
        </>
      ),
    },
  ];

  if (error) return <p>{error}</p>;

  return (
    <>
      <BackButton />
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No exchange rates found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};
export default JobMaster;
